import HandleResponses from '@common/utils/handleResponses';

import bdrAxios from '../../../axios-bdr';
import tmsMdmAxiosInstance from '../../../tms-mdm-axios';
import axios from '../../../axios';
import { InvertedMovements } from 'pando-constants';
import { invert } from 'lodash';


function getAxiosBySection(section) {
  return section === 'bdr' ? bdrAxios : tmsMdmAxiosInstance;
}

const actions = {
  async create({ commit }, { section, data }) {
    commit('changesCheck', true);
    try {
      const result = await tmsMdmAxiosInstance.post(`${section}/`, { data });
      if (result && result.data) {
        commit('appendNew', { data: result.data });
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('changesCheck', false);
    }
  },

  async update({ commit }, { section, Id, data }) {
    commit('changesCheck', true);
    try {
      const result = await tmsMdmAxiosInstance.put(`/${section}/${Id}`, { data });
      if (result && result.data) {
        commit('updateExisting', { Id, data: result.data });
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('changesCheck', false);
    }
  },

  async show({ commit }, { section, id }) {
    try {
      commit('setShowLoading', true);
      const result = await tmsMdmAxiosInstance(`/${section}/${id}/show`);
      commit('setShowDetails', { id, data: result.data });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setShowLoading', false);
    }
  },

  async search({ commit }, { section, params }) {
    if (params.page === 1) {
      commit('setLoadingStatus', true);
    } else {
      commit('paginationCheck', true);
    }
    try {
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance(`/${section}/search`, { params });
      if (result && result.data) {
        commit('setAll', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoadingStatus', false);
    }
  },

  async searchTransporters({ commit }, { params, data }) {
    try {
      if (params.page === 1) {
        commit('setLoadingStatus', true);
      } else {
        commit('paginationCheck', true);
      }
      let updatedData = data;
      if (data.movement) {
        const movementType = invert(InvertedMovements);
        // temporary fix
        updatedData = Object.assign(
          data,
          {
            movement: Number.isNaN(parseFloat(data.movement))
              ? movementType[data.movement.toLowerCase()]
              : data.movement,
          },
        );
      }
      const result = await tmsMdmAxiosInstance.put('transporter/activeTransporters', updatedData, { params });
      if (result && result.data) {
        commit('setAll', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoadingStatus', false);
    }
  },
  async countTransporters(context, { params, data }) {
    try {
      let updatedData = data;
      if (data.movement) {
        const movementType = invert(InvertedMovements);
        updatedData = Object.assign(
          data,
          {
            movement: Number.isNaN(parseFloat(data.movement))
              ? movementType[data.movement.toLowerCase()]
              : data.movement,
          },
        );
      }
      const result = await tmsMdmAxiosInstance.put('transporter/activeTransporters/count', updatedData, { params });
      return result && result.data ? result.data : null;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async autoCompleteSearch({ commit }, { params }) { // eslint-disable-line
    try {
      const result = await axios('autocomplete/contract_source', { params });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async paginate({ commit }, { section, params }) {
    try {
      if (params.page === 1) {
        commit('setLoadingStatus', true);
      } else {
        commit('paginationCheck', true);
      }
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance(`/${section}`, { params });
      commit('setAll', result.data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoadingStatus', false);
    }
  },

  async bulkUpload({ commit }, { section, formData, subPath = '' }) {
    commit('setuploadStatus', true);
    try {
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance.post(`/${section}/bulkupload/${subPath}`, formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setuploadStatus', false);
      return HandleResponses.Status(error);
    }
  },

  async associatedMaterialbulkUpload({ commit }, { section, formData }) {
    commit('setuploadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance.post(`/${section}/associated_material/bulkupload`,
        formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setuploadStatus', false);
      return HandleResponses.Status(error);
    }
  },

  async uploadStatus({ commit }, { section, uploadType }) {
    try {
      let url = `/${section}/upload_status`;
      if (uploadType) {
        url = `${url}?type=${uploadType}`;
      }
      if (section === 'consignee' && uploadType === null) {
        url = `${url}?type=1`;
      }
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance(url);
      if (result.data && result.data.code === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return HandleResponses.Status(error);
    }
  },

  async associatedMaterialUploadStatus({ commit }, { section }) {
    try {
      const result = await tmsMdmAxiosInstance(`/${section}/associated_material/upload_status`);
      if (result.data && result.data.code === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return HandleResponses.Status(error);
    }
  },
  async dedicated_truck_history_export({ commit }, { section, params }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: '/dedicatedtruck/history_export',
        method: 'GET',
        params,
        responseType: 'blob' });
      if (result.size) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${section}-export-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return (result.size === 0) ? 'EXPORT_VIA_EMAIL' : false;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setDownloadStatus', false);
    }
  },
  async export({ commit }, { section, params }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: '/export',
        method: 'GET',
        params,
        responseType: 'blob' });
      if (result.size) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${section}-export-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return (result.size === 0) ? 'EXPORT_VIA_EMAIL' : false;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setDownloadStatus', false);
    }
  },

  async rejectDownload({ commit }, { section, transactionIds }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: `/${section}/rejected/download?transaction_ids=${transactionIds.join(',')}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${section}-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },

  async associatedMaterialRejectDownload({ commit }, { section }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: `/${section}/associated_material/rejected/download`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${section}-associated-material-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },

  // async orderSearch({ commit }, { params }) {
  //   try {
  //     let result = [];
  //     if (params.page === 1) {
  //       commit('setLoadingStatus', true);
  //     } else {
  //       commit('paginationCheck', true);
  //     }
  //     result = await tmsMdmAxiosInstance('order/search_consignees', { params });
  //
  //     if (result && result.data) {
  //       commit('setAll', result.data);
  //     }
  //     return result.data;
  //   } catch (error) {
  //     return HandleResponses.Status(error);
  //   } finally {
  //     commit('paginationCheck', false);
  //     commit('setLoadingStatus', false);
  //   }
  // },

  async consignee_favourites({ commit }, { params }) {
    try {
      commit('resetAll', []);
      if (params.page === 1) {
        commit('setLoadingStatus', true);
      } else {
        commit('paginationCheck', true);
      }
      const result = await tmsMdmAxiosInstance('consignee/favourites', { params });
      if (result && result.data) {
        commit('setAll', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoadingStatus', false);
    }
  },

  async gst({ commit }) {
    try {
      const result = await tmsMdmAxiosInstance('vehicle/gst-types');
      commit('setGST', result.data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async excludeList({ commit }, { params }) {
    try {
      const result = await tmsMdmAxiosInstance('/vehicle_type', { params });
      commit('setExcludeVehicles', result.data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async stopBdr({ commit }, { params }) {
    try {
      const result = await bdrAxios.put(`/bdr/${params.id}`, { data: { stop_update: true } });
      if (result && result.data) {
        commit('updateExisting', { data: result.data });
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async stopAllBdr({ commit }, { bdrIds }) {
    try {
      const result = await bdrAxios.post('/bdr/stop_all', { data: { bdr_ids: bdrIds } });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async exceptionList({ commit }, { config, isNoPay }) {
    try {
      const exceptions = await tmsMdmAxiosInstance('/exception');
      let postingExceptions = { data: [] };
      if (!isNoPay && (config.retry_freight_invoice_posting || config.retry_freight_provision)) {
        postingExceptions = await axios('/v2/shipper/exception');
      }
      const data = [...exceptions.data, ...postingExceptions.data];
      commit('setExceptionList', data);
      return data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async downloadException({ commit }, params) {
    try {
      commit('setDownloadStatus', true);
      const postingType = [41, 42];
      let result;
      if (postingType.includes(params.type)) {
        const urlPrefix = 'v2/shipper';
        const url = `${urlPrefix}/exception/download?type=${params.type}`;
        result = await axios({ url,
          method: 'GET',
          responseType: 'blob' });
      } else {
        const url = `exception/download?type=${params.type}`;
        result = await tmsMdmAxiosInstance({ url,
          method: 'GET',
          responseType: 'blob' });
      }
      if (new Blob([result]).size) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${params.label}-exceptionList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        return {};
      }
      return { email_triggered: true };
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setDownloadStatus', false);
    }
  },

  async additionalRejection({ commit }, { section, transactionIds }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: `/${section}/rejected_additional_info/download?transaction_ids=${transactionIds.join(',')}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${section}-consignee-additional-info-rejections-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },
  async getBdrHistory({ commit }, { bdrId }) {
    commit('setDownloadStatus', true);
    try {
      const result = await bdrAxios({ url: `/bdr/bdr_history/${bdrId}` });
      if (result) {
        commit('setCurrentBdr', result.data);
        return result.data;
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },
  async getDedicatedTruckHistory({ commit }, { dedicatedTruckId }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: `/dedicatedtruck/history/${dedicatedTruckId}` });
      if (result) {
        commit('setDedicatedTruckHistory', result.data);
        return result.data;
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },
  async getBdrSlabRates({ commit }, { bdrCategory }) {
    try {
      const result = await bdrAxios({ url: `/bdr/bdr_slab/${bdrCategory}` });
      if (result) {
        commit('setBdrSlabs', result.data);
        return result.data;
      }
      return [];
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getSkuCategory({ commit }, { id, params, unit }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/contract/${id}/slab_rates/${unit}`, { params });
      if (result) {
        commit('setSlab', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },

  async getViaRoutes({ commit }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/contrat/${id}/via_routes`, { params });
      if (result) {
        commit('setSlab', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },

  async getMovementRates({ commit }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/contrat/${id}/movement_rates`, { params });
      if (result) {
        commit('setSlab', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },

  async getContractDetails({ commit }, { id }) {
    commit('setLoadingStatus', true);
    try {
      const result = await tmsMdmAxiosInstance(`/contrat/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoadingStatus', false);
    }
  },

  async getPurchaseOrderDetails({ commit }, { id }) {
    commit('setLoadingStatus', true);
    try {
      const result = await tmsMdmAxiosInstance(`/purchase_order/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoadingStatus', false);
    }
  },

  /**
     * @method getContractHistory
     * @param id of the contract
     * Get expired contracts for a contract
     */
  async getContractHistory({ commit, state }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/expired_contract/${id}`, { params });
      // This is done since we will be showing only 5 expired contracts in Timeline
      result.data = result.data.slice(0, 5);
      if (result) {
        commit('setAll', { ...state.all, Expired: result.data });
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },

  /**
     * @method getContractFuture
     * @param id of the contract
     * Get Future contracts for a contract
     */
  async getContractFuture({ commit, state }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/future_contract/${id}`, { params });
      if (result) {
        commit('setAll', { ...state.all, Future: result.data });
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },

  /**
     * @method deleteContract
     * @param id of the contract
     * Delete Future Contract with the given id
     */
  async deleteContract(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.delete(`/future_contract/${id}`);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async blacklistVehicle(_, { data }) {
    try {
      const result = await tmsMdmAxiosInstance.post('blacklist_vehicle', { data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async blacklistDriver(_, { data }) {
    try {
      const result = await tmsMdmAxiosInstance.post('blacklist_driver', { data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async blacklistVehicleHistory({ commit }, data) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/blacklist_vehicle/${data.id}`);
      if (result) {
        commit('setAll', result.data);
      }
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },
  // async blacklistDriverHistory({ commit }, data) {
  //   commit('setShowLoading', true);
  //   try {
  //     if (data.id) {
  //       const result = await tmsMdmAxiosInstance(`/blacklist_driver/${data.id}`);
  //       if (result) {
  //         commit('setAll', result.data);
  //       }
  //       return result && result.data;
  //     }
  //     return {};
  //   } catch (err) {
  //     return HandleResponses.Status(err);
  //   } finally {
  //     commit('setShowLoading', false);
  //   }
  // },
  async fetchVehicleStatus(_, data) {
    try {
      const result = await tmsMdmAxiosInstance(`/blacklist_vehicle/${data.id}/status/`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async fetchDriverStatus(_, data) {
    try {
      const result = await tmsMdmAxiosInstance(`/blacklist_driver/${data.id}/status/`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getKmSlabRates({ commit }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/contract/${id}/km_slab_rates`, { params });
      if (result) {
        commit('setSlab', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },
  async getSlabRates({ commit }, { id, params, unit }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/contract/${id}/slab_rates/${unit}`, { params });
      if (result) {
        commit('setSlab', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },
  async getHeaders({ commit }, { section }) {
    try {
      commit('setLoadingStatus', true);
      const result = await tmsMdmAxiosInstance.get(`/${section}/config_fields`);
      if (result && result.data) {
        commit('setHeader', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },
  async getExcelHeader(_, { section }) {
    try {
      const result = await tmsMdmAxiosInstance({ url: `${section}/excel_header`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${section}_bulk_upload.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async calculateRate(_, params) {
    try {
      const result = await tmsMdmAxiosInstance('contract/calculate', { params });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async fetchPincodeRatecard(_, pincode) {
    try {
      const result = await tmsMdmAxiosInstance(`/pincodeRatecard/${pincode}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editRateMatrix(_, { payload, contractId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`contract/${contractId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async deleteSlab(_, payload) {
    try {
      const result = await tmsMdmAxiosInstance.delete(`/contract/${payload.contractId}/slab_rates/${payload.slabId}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async deleteSkuCategory(_, payload) {
    try {
      const result = await tmsMdmAxiosInstance.delete(`/contract/${payload.contractId}/sku_category/${payload.categoryId}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async fetchCount(_, mdmType) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/${mdmType}/count`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  }
};

export default actions;
